export const REGEXP_EMAIL = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const REGEXP_PHONE = /^\d{2,17}$/;

/** No leading or trailing spaces */
export const REGEXP_SPACE = /^[^ ].+[^ ]$/;
